export const environment: BrandEnvironment = {
  production: true,
  legal: {
    termsVersion: '2026-02-15',
    privacyVersion: '2026-02-15',
    cookies: '2026-02-15',
  },
  apiUrl: '/api', // Backend API base URL
  // sentry: {
  //   SENTRY_AUTH_TOKEN:
  //     '',
  //   sentryEnabled: true,
  //   sentryDsn: 'https://9eb8d01b9ca795f0fe94a5d4aaa7f4af@o4511162680082432.ingest.de.sentry.io/4511162686242896',
  //   release: 'latest',
  //   environmentName: 'production',
  // },
};
